// extracted by mini-css-extract-plugin
export default {"headerWrapper":"bQcS1"};